import { DashboardReco } from '../../../api/dashboard/item/dashboardReco';
import { Equipment } from '../../../api/dashboard/item/itemSection/equipment';
import { ItemSection } from '../../../api/dashboard/item/itemSection/itemSection';
import { Service } from '../../../api/dashboard/item/itemSection/service';
import { PushSubItemViewModel } from '../../../model/home/pushSubItem.view-model';
import { SubItemViewModel } from '../../../model/home/subItem.view-model';
import { SubItemTypeEnum } from '../../../model/home/subItemTypeEnum';
import { DashboardV7MapperUtils } from '../dashboard/dashboardV7-utils.mapper';

export class EntertainmentMapper {
    /**
     * Extract tv and entertainments items
     * @param {ItemSection} itemSection
     * @param {any} dashboardTranslations
     * @return {SubItemViewModel[]}
     */
    public static extractSubItemEntertainment(
        itemSection: ItemSection,
        dashboardTranslations: any,
    ): SubItemViewModel[] | null {
        const subItemsViewModel: SubItemViewModel[] = [];

        EntertainmentMapper.addSubItems(itemSection, dashboardTranslations, subItemsViewModel, [
            // Sosh TV app option
            { data: itemSection.soshTvAppOption },

            // TV Orange
            ...(itemSection.services || [])
                .filter((service) => service.id === 'TVORANGE')
                .map((service) => ({ data: service })),

            // Equipments
            ...(itemSection.equipments || []).map((equipment) => ({ data: equipment, trackingArea: 'care_hp_maison' })),

            // Reco SetTopBox N°1
            {
                data: itemSection.recoSetTopBox,
                trackingArea: 'care_hp_maison',
                trackingName: 'souscrire_tv_orange_clic',
            },

            // Reco SetTopBox N°2
            {
                data: itemSection.recoSecondSetTopBox,
                trackingArea: 'care_hp_maison',
                trackingName: 'obtenir_second_decodeur_clic',
            },

            // Reco TV Key
            { data: itemSection.recoTvKey, trackingArea: 'care_hp_maison', trackingName: 'obtenir_cle_tv' },

            // Add Sosh TV app options
            { data: itemSection.addSoshTvOptions, trackingName: 'tv_orange_chez_sosh' },

            // Share TV
            { data: itemSection.shareTv, trackingName: 'partager_tv_orange' },

            // Other services
            ...(itemSection.services || [])
                .filter((service) => service.id !== 'TVORANGE')
                .map((service) => ({ data: service })),

            // Reco Basic Sosh TV
            { data: itemSection.recoBasicSoshTv, trackingName: 'souscrire_tv_basic' },
        ]);

        // Reco
        if (Object.prototype.hasOwnProperty.call(itemSection, 'reco')) {
            const pushSubItem: PushSubItemViewModel = DashboardV7MapperUtils.getCommercialInfo(itemSection.reco, true);
            pushSubItem.label = itemSection.reco.content;
            pushSubItem.detail = null;
            subItemsViewModel.push(DashboardV7MapperUtils.extractZid('recoEntertainement', pushSubItem));
        }

        return subItemsViewModel;
    }

    public static extractImage(isSosh: boolean, itemSection: ItemSection): string {
        return itemSection.title && itemSection.title.imageUrl
            ? itemSection.title.imageUrl
            : isSosh
              ? DashboardV7MapperUtils.defaultTvImageSosh
              : DashboardV7MapperUtils.defaultTvImageOrange;
    }

    private static addSubItems(
        itemSection: ItemSection,
        dashboardTranslations: any,
        subItems: SubItemViewModel[],
        inputs: { data: Service | Equipment | DashboardReco; trackingArea?: string; trackingName?: string }[],
    ): void {
        inputs?.forEach((input) => {
            if (input && input.data) {
                const subItem = new SubItemViewModel();
                const data = input.data;
                subItem.type = SubItemTypeEnum.picto;
                subItem.cid = itemSection.cid;
                subItem.label = data.label;

                // Define equipment link if data is clickable
                const equipement = data as Equipment;
                if (equipement.clickable !== false && equipement.usageCode && !data.link) {
                    data.link = dashboardTranslations.entertainment.equipmentLinks[equipement.usageCode];
                }

                // Warning : link may be defined even when clickable is missing
                if (equipement.clickable !== false) {
                    subItem.link = data.link;
                }
                subItem.picto = dashboardTranslations['picto'][data.imageId || (data as Service).id];

                subItem.trackingArea = input.trackingArea || 'care_hp_tvdivertissement';
                subItem.trackingName = input.trackingName || data.label;

                subItem.detail = [];
                subItem.detailLong = [];
                const detail = (data as Service | Equipment).detail || (data as DashboardReco).content;
                if (detail) {
                    subItem.detail.push(detail);
                    subItem.detailLong.push(detail);
                }

                subItems.push(subItem);
            }
        });
    }
}
